// extracted by mini-css-extract-plugin
export default {"container":"order-book_container__3J7O2","scrollWrapper":"order-book_scrollWrapper__i5itw","tabViewWrapper":"order-book_tabViewWrapper__+MHT8"};